import { FlowComponent } from '../../../flow.min.js';
import styles from './styles.js';
import { notificationChannel } from '../../../stores/index.js';

const template = FlowComponent.html`
    <div id="container" class="space-y-2">
        <!-- Los toasts se inyectarán aquí dinámicamente -->
    </div>
`;

export class FlowToast extends FlowComponent {
    static get styles() { return styles; }
    static get template() { return template; }

    onMount() {
        super.onMount();
        const container = this.root.querySelector('#container');

        // Nos suscribimos al canal de notificaciones
        notificationChannel.bind(this.root.host, (el, notification) => {
            if (!notification) return;
            this.#renderToast(container, notification);
        });
    }

    #renderToast(container, { message, type, id }) {
        const toast = document.createElement('div');
        const bgClass = type === 'error' ? 'bg-red-600' : type === 'success' ? 'bg-green-600' : 'bg-blue-600';
        
        toast.className = `toast ${bgClass} text-white px-6 py-3 rounded-lg shadow-xl flex items-center justify-between min-w-[300px] mb-2`;
        toast.innerHTML = `
            <span>${message}</span>
            <button class="ml-4 text-white hover:text-gray-200">&times;</button>
        `;

        toast.querySelector('button').onclick = () => toast.remove();

        container.appendChild(toast);

        // Auto-remove después de 5 segundos
        setTimeout(() => {
            if (toast.parentNode) {
                toast.style.opacity = '0';
                toast.style.transform = 'translateX(100%)';
                toast.style.transition = 'all 0.3s ease-in';
                setTimeout(() => toast.remove(), 300);
            }
        }, 5000);
    }
}

customElements.define('flow-toast', FlowToast);
